export default __webpack_public_path__ + "static/transitionSlide-bbd7c5c5bdc85bf71bc0396339c436de.png";